import { store } from '@/store/store';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { InclusionTypes } from '@/models/VariousEnum';
import LocalStoreService from '@/store/local.store';
import { isPharmacistFitOrderActivated } from '@/config/app.config';

@Component
export default class TemplateSo extends Vue {
  @Prop({ default: false })
  public showOrderConfirmationMessage!: boolean;
  @Prop({ default: '' })
  public inclusionType!: string;
  @Prop({ default: false })
  public isInclusion!: boolean;
  @Prop({ default: false })
  public showFollowup!: boolean;
  @Prop({ default: false })
  public isDoctor!: boolean;
  @Prop({ default: false })
  public isPharmacist!: boolean;
  @Prop({ default: false })
  public isProFit!: boolean;

  public pharmacistOrderFitActivated = false;

  public downloadFileExists = false;

  public get confirmationHeader(): string {
    switch  (this.inclusionType) {
      case 'Inclusion':
        switch  (store.state.inclusionType) {
          case InclusionTypes.fit:
            return 'confirmation.headerFIT';

          case InclusionTypes.colo:
            return 'confirmation.header';

          case InclusionTypes.refusal:
            return 'confirmation.headerRefusal';

          default:
            return '';
        }
      case 'Exclusion':
      case 'Refusal':
        return 'confirmation.headerRefusal';

      case 'Advice':
        return 'confirmation.advice';

      default:
        return 'confirmation.header';
    }
  }

  protected mounted(): void {
    const templateKey = LocalStoreService.localItemKeys.followUpFilename;
    this.pharmacistOrderFitActivated = isPharmacistFitOrderActivated(this.$route.params.screening);
    this.downloadFileExists = LocalStoreService.getItem(templateKey) === '' ? false : true;
  }

  protected checkInclusionType(): string {
    if (this.isPharmacist) {
      return 'customConfirmation.inclusionFit';
    } else {
      switch (store.state.inclusionType) {
        case InclusionTypes.fit: {
          return 'customConfirmation.inclusionFit';
        }
        case InclusionTypes.colo: {
          return 'customConfirmation.inclusionColo';
        }
        default: {
          return '';
        }
      }
    }
  }

  protected checkConfirmationType(): string {
    switch (this.inclusionType) {
      case 'Refusal': {
        return 'customConfirmation.refusal';
      }
      case 'Exclusion': {
        return 'customConfirmation.exclusion';
      }
      default: {
        return '';
      }
    }
  }

  protected getDownloadButtonName(): string {
    switch (this.inclusionType) {
      case 'Refusal': {
        return 'customConfirmation.downloadRefusalConfirmation';
      }
      case 'Exclusion': {
        return 'customConfirmation.downloadRefusalConfirmation';
      }
      case 'Inclusion': {
        return 'customConfirmation.downloadConfirmation';
      }
      default:
        return '';
    }
  }
}
